module.exports = __webpack_public_path__ + "static/media/logo.0cf378e8.svg";